import {
  useGetUnreadRemindersQuery,
  useMarkReminderAsReadMutation,
} from "../store/services/useReminderApi";

export const useUserReminders = () => {
  const { data, isLoading } = useGetUnreadRemindersQuery();
  const [markAsRead, { isLoading: isMarking }] =
    useMarkReminderAsReadMutation();

  const reminders = data?.data || [];

  const handleRead = async (id) => {
    await markAsRead(id).unwrap();
  };

  return {
    reminders,
    isLoading,
    handleRead,
    isMarking,
  };
};
